import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3876de00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "d-flex flex-column flex-wrap flex-sm-nowrap p-0" }
const _hoisted_4 = {
  key: 0,
  class: "svg-icon svg-icon-3"
}
const _hoisted_5 = {
  key: 1,
  class: "svg-icon svg-icon-3 svg-icon-warning"
}
const _hoisted_6 = { class: "d-flex flex-wrap fw-bold fs-6 pe-2" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex align-items-center text-gray-400 me-5"
}
const _hoisted_8 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_9 = {
  key: 1,
  class: "d-flex align-items-center text-gray-400 me-5"
}
const _hoisted_10 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_11 = {
  key: 2,
  class: "d-flex align-items-center text-gray-400 me-5"
}
const _hoisted_12 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_13 = { class: "card mb-5 mb-xl-10" }
const _hoisted_14 = { class: "card-header" }
const _hoisted_15 = { class: "card-title m-0" }
const _hoisted_16 = { class: "fw-boldest m-0" }
const _hoisted_17 = { class: "card-body p-9" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "form-group d-flex flex-wrap" }
const _hoisted_21 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group d-flex flex-wrap" }
const _hoisted_24 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group d-flex flex-wrap" }
const _hoisted_28 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-group d-flex flex-wrap" }
const _hoisted_31 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "form-group d-flex flex-wrap" }
const _hoisted_35 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "form-group d-flex flex-wrap" }
const _hoisted_38 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "form-group d-flex flex-wrap" }
const _hoisted_42 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_43 = { class: "col-md-6" }
const _hoisted_44 = { class: "form-group d-flex flex-wrap" }
const _hoisted_45 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "form-group d-flex flex-wrap" }
const _hoisted_49 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "form-group d-flex flex-wrap" }
const _hoisted_52 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-md-12" }
const _hoisted_55 = { class: "form-group d-flex flex-wrap" }
const _hoisted_56 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-md-6" }
const _hoisted_59 = { class: "form-group d-flex flex-wrap" }
const _hoisted_60 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_61 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_63 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_64 = { class: "indicator-label" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1))
const _hoisted_66 = { class: "indicator-progress" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createBlock(_component_el_form, {
    onSubmit: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
    rules: _ctx.rules,
    model: _ctx.formData,
    ref: "formRef"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", null, [
              _createTextVNode(_toDisplayString(_ctx.ExceptionHandling.id ? "#" + _ctx.ExceptionHandling.id + " / " : "") + " " + _toDisplayString(_ctx.ExceptionHandling.title ? _ctx.ExceptionHandling.title + " / " : "") + " " + _toDisplayString(_ctx.ExceptionHandling.__show.progress) + " ", 1),
              (_ctx.ExceptionHandling.level == 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr081.svg" })
                  ]))
                : (_ctx.ExceptionHandling.level == 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr081.svg" })
                    ]))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.ExceptionHandling.customer_service_name)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com006.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.ExceptionHandling.customer_service_name), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.ExceptionHandling.sale_order_number)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com005.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.ExceptionHandling.sale_order_number), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.ExceptionHandling.created_at)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen013.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(_ctx.ExceptionHandling.created_at)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.t("exceptionHandlings.information")), 1)
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.t("exceptionHandlings.type")), 1),
                _createVNode(_component_el_form_item, { prop: "type" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.type,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.type) = $event)),
                      clearable: "",
                      disabled: "",
                      style: {"width":"100%"},
                      placeholder: " "
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.type, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("exceptionHandlings.createdDate")), 1),
                _createVNode(_component_el_form_item, { prop: "created_at" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formData.created_at,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.created_at) = $event)),
                      disabled: "",
                      type: "date",
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.t("exceptionHandlings.title")), 1),
                _createVNode(_component_el_form_item, { prop: "title" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.title,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.title) = $event)),
                      type: "text",
                      placeholder: _ctx.t('common.plsEnter'),
                      clearable: ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.t("exceptionHandlings.customerServiceAgent")), 1),
                _createVNode(_component_el_form_item, { prop: "customer_service_name" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.customer_service_name,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.customer_service_name) = $event)),
                      type: "text",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.t("exceptionHandlings.fulfillmentOrder")), 1),
                _createVNode(_component_el_form_item, { prop: "fulfillment_order_number" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { prop: "fulfillment_order_number" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.fulfillment_order_number,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.fulfillment_order_number) = $event)),
                          disabled: "",
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.t("exceptionHandlings.progress")), 1),
                _createVNode(_component_el_form_item, { prop: "progress" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.progress,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.progress) = $event)),
                      clearable: "",
                      placeholder: _ctx.t('common.plsSelect'),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.progress, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.t("exceptionHandlings.customerRequest")), 1),
                _createVNode(_component_el_form_item, { prop: "customer_request" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.customer_request,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.customer_request) = $event)),
                      type: "text",
                      placeholder: _ctx.t('common.plsEnter'),
                      clearable: ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.t("exceptionHandlings.solution")), 1),
                _createVNode(_component_el_form_item, { prop: "solution" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.solution,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.solution) = $event)),
                      clearable: "",
                      placeholder: _ctx.t('common.plsSelect'),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.solution, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.t("warningRules.category")), 1),
                _createVNode(_component_el_form_item, { prop: "category" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.category,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.category) = $event)),
                      clearable: "",
                      filterable: "",
                      placeholder: _ctx.t('common.plsSelect'),
                      style: {"width":"100%"},
                      onChange: _ctx.handleCategory
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.category, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder", "onChange"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.t("warningRules.levelOptions")), 1),
                _createVNode(_component_el_form_item, { prop: "cargo_damage_level" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.cargo_damage_level,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.cargo_damage_level) = $event)),
                      clearable: "",
                      filterable: "",
                      placeholder: _ctx.t('common.plsSelect'),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCargoDamageLevel, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.t("exceptionHandlings.solutionRemark")), 1),
                _createVNode(_component_el_form_item, { prop: "solution_remark" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.solution_remark,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.solution_remark) = $event)),
                      type: "textarea",
                      placeholder: _ctx.t('common.plsEnter'),
                      clearable: ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.t("exceptionHandlings.ticketClosedDate")), 1),
                _createVNode(_component_el_form_item, { prop: "closed_date" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formData.closed_date,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.closed_date) = $event)),
                      type: "date",
                      placeholder: _ctx.t('common.pickDate'),
                      style: {"width":"100%"},
                      onChange: _cache[12] || (_cache[12] = ($event: any) => (
                    _ctx.commonChangeDefaultDate($event, _ctx.formData, 'closed_date')
                  ))
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary align-self-center me-2",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
          }, [
            _hoisted_62,
            _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
          ]),
          _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_63, [
            _createElementVNode("span", _hoisted_64, [
              _hoisted_65,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
            ]),
            _createElementVNode("span", _hoisted_66, [
              _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
              _hoisted_67
            ])
          ])), [
            [_directive_auth, { auth: ['update'] }]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["rules", "model"]))
}